import { createContext, useContext } from "react";

/** Contexto do FormField: liga label/ajuda/erro ao controle (id, aria-describedby, aria-invalid). */
export type FieldContextValue = {
  id: string;
  describedBy?: string;
  invalid: boolean;
  required?: boolean;
  disabled?: boolean;
};

export const FieldContext = createContext<FieldContextValue | null>(null);

/** Props ARIA para um controle dentro de <FormField>. Props explícitas do controle vencem. */
export function useFieldControlProps<P extends { id?: string; "aria-describedby"?: string; "aria-invalid"?: unknown; required?: boolean; disabled?: boolean }>(
  props: P,
  invalidProp?: boolean,
) {
  const ctx = useContext(FieldContext);
  const invalid = invalidProp ?? ctx?.invalid ?? false;
  return {
    id: props.id ?? ctx?.id,
    "aria-describedby": props["aria-describedby"] ?? ctx?.describedBy,
    "aria-invalid": (props["aria-invalid"] as boolean | undefined) ?? (invalid || undefined),
    required: props.required ?? ctx?.required,
    disabled: props.disabled ?? ctx?.disabled,
    invalid,
  };
}
